export enum EApiSuggestionSource {
    Text, 
    Image
}

export interface IApiSuggestionResponse {
    source: EApiSuggestionSource;
    score: number;
    value: string;
}